import styles from './ChartLegend.module.css';
import { themeColors } from '@/theme/colors';

export const ChartLegend = () => {
  return (
    <div className={styles.content}>
      <span>
        <span className={styles.dot} style={{ backgroundColor: themeColors.colorLeft }} />
        <span className={styles.text}>Left</span>
      </span>

      <span>
        <span className={styles.dot} style={{ backgroundColor: themeColors.colorRight }} />
        <span className={styles.text}>Right</span>
      </span>
    </div>
  );
};
